<template>
  <div id="">
    <router-view name="auth" ></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'App',
  computed: mapState(['isMenuVisible','api_url','data_content','user','isEditing','client']),
  data: () => ({
      validationToken: true
  }), 
  mounted() {
  },
 
};
</script>
<style >
@import "./assets/css/bootstrap.css";
@import "./assets/style.css";
@import "./assets/css/estilo.css";
@import "./assets/css/font-icons.css";
@import "./assets/css/animate.css";
@import "./assets/css/magnific-popup.css";
#content{
  min-height: 50vh;
}
.material-icons{
      font-family: Material Icons !important;
}
</style>
